enum CustomerType {
    NotSet = 0,
    Personal = 1,
    Business = 2
}
export default CustomerType;
